import React, { useState, useEffect } from "react";
import BoardsMenu from "../../assets/icons/BoardsMenu";
import UploadFile from "../../assets/icons/UploadFile";
import DefaultButton from "../default-button/DefaultButton";
import PageSwapper from "../PageSwapperButtons/PageSwapper";
import CategoryPage from "./CategoryPage/CategoryPage";
import DocumentPage from "./DocumentsPage/DocumentPage";
import { useHookstate } from "@hookstate/core";
import { updateLocalStateRaw } from "../../misc/utils";

export default function SocialTranscript() {
  const localState = useHookstate({});
  const state: Record<string, any> = localState.get();
  const activePage = state.activePage || "Категории";

  const categoryBtn = (
    <DefaultButton
      buttonText="Категории"
      Icon={BoardsMenu}
      additionalStyle="p-2 border-none rounded-lg"
      onClick={() => handleButtonClick("Категории")}
    />
  );

  const documentBtn = (
    <DefaultButton
      buttonText="Поданные заявки"
      Icon={UploadFile}
      additionalStyle="p-2 border-none rounded-lg"
      onClick={() => handleButtonClick("Поданные заявки")}
    />
  );

  const handleButtonClick = (btnName: string) => {
    updateLocalStateRaw(localState, 'activePage')(btnName);
  };

  return (
    <div className="text-black p-8 overflow-x-hidden">
      <PageSwapper btns={[categoryBtn, documentBtn]} activeBtn={activePage} />
      {activePage === "Категории" && <CategoryPage />}
      {activePage === "Поданные заявки" && <DocumentPage />}
    </div>
  );
}
